// import * as types from './types';
// import {get, set} from 'lodash';
// import {SELECT_BOX, MINIMIZE_BOX, MAXIMIZE_BOX, PIN_BOX} from '../../../plugins/box-widget/store.functions';
// import { findCheclistItemByName } from '../models/checklists.model';
// import { defaultBookingOverview } from '../models/booking-overview.model';
// import { DataStates } from '../../../store/global/data-state';


import { bookingReportsMutations } from "./reports/mutations";
import { bookingsMutations } from "./bookings/mutations";
import { artistMutations } from "./artists/mutations";
import { bookingPromotersMutations } from "./promoters/mutations";
import { venueMutations } from "./venues/mutations";
import { bookingPluginsMutations } from "./plugins/mutations";
import {tourMutation} from './tours/mutations'
import { BookingModulePluginStore } from "./plugins";
import { templateMutations } from "./templates/mutations"

// import { documentMutations } from './documents/mutations'; 
// import { travelDetailsMutations } from './travel-details/mutations';
// import { localDetailsMutations } from './local-details/mutations';

// import { BookingArtist, setBookingStatusColorMap } from '../models/booking-artist.model';
// import { createCalendarDateArtist } from '../models/calendar-date-artist.model';
// import { getDefaultFilter } from '../models/filter.model';
// import { append12Months, bookingMonthToDate } from '../models/booking-month.model';

const BOOKING_STATUS_NAME = "booking_status_name";

export const mutations = {
  ...bookingsMutations,
  ...artistMutations,
  ...bookingPromotersMutations,
  ...bookingReportsMutations,
  ...venueMutations,

  ...BookingModulePluginStore.mutations,

  ...tourMutation,
  ...templateMutations
}